import React from 'react';
import { useHistory } from 'react-router';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import ItemDoesntExistError from 'Shared/components/ItemDoesntExistError/ItemDoesntExistError';

type Props = {
  handleBackClick?: Function;
};

const GoalDoesNotExist = ({ handleBackClick }: Props) => {
  const history = useHistory();

  const handleClick = () => {
    if (handleBackClick) handleBackClick();
    else history.push(PageUrls.GOALS_PAGE);
  };

  return (
    <ItemDoesntExistError
      title="We couldn’t find this Goal."
      description="You either no longer have access to it, or it has been deleted."
      buttonCallback={handleClick}
    />
  );
};

export default GoalDoesNotExist;
